import { createSlice, PayloadAction, createSelector } from 'redux-starter-kit';
import { selectAppState } from '../../../App/state/selectors';
import { SubmitProblemPayloadProps } from '../types';

export interface ProblemReportState {
  error?: string;
}
const initialState: ProblemReportState = {};

const ProblemReportSlice = createSlice({
  slice: 'problemReport',
  initialState: initialState,
  reducers: {
    // eslint-disable-next-line
    submitProblem(state, data: PayloadAction<SubmitProblemPayloadProps>) {},
    // eslint-disable-next-line
    submitProblemSuccess(state, action: PayloadAction) {},
    submitProblemFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
  },
});

const {
  actions,
  reducer,
  selectors: { getProblemReport },
} = ProblemReportSlice;

export const {
  submitProblem,
  submitProblemFail,
  submitProblemSuccess,
} = actions;
export const selectors = {
  selectProblemReportState: createSelector([selectAppState], getProblemReport),
};
export default reducer;
